// By Location — where is pending and blocked work concentrated?
import { ExportCsvButton } from '../../components/ui';
import { downloadCsv } from '../../utils/csv.js';
import { useInfoModal, PageChrome, InfoModal, dqBadgeFor } from './Chrome.jsx';
import { fmtN, fmtH1, SUB_PAGES } from './helpers.js';

// Built here: the dashboard payload already carries every row this table shows.
const CSV_COLUMNS = [
  { key: 'ns_location_name', label: 'Location' },
  { key: 'site_code',        label: 'Site' },
  { key: 'record_count',     label: 'Records' },
  { key: 'pending_hours',    label: 'Pending Hours' },
  { key: 'gap_hours',        label: 'Gap Hours' },
  { key: 'gaps',             label: 'Gaps' },
];

export function PageLocations({ stats, nav }) {
  const info = useInfoModal();
  const helpEntry = SUB_PAGES.find((p) => p.id === 'locations');
  const rows = stats.top_locations || [];

  const totalPending = rows.reduce((a, r) => a + (r.pending_hours || 0), 0);
  const totalGap = rows.reduce((a, r) => a + (r.gap_hours || 0), 0);

  return (
    <>
      <PageChrome
        title="By Location"
        subtitle={`Top ${rows.length} locations by pending + gap volume.`}
        onHome={() => nav.goSubPage('overview')}
        onBack={nav.goBack} canBack={nav.canBack}
        onInfo={info.onOpen}
        dqBadge={dqBadgeFor(stats, () => nav.goSubPage('data_quality'))}
      />

      {rows.length === 0 ? (
        <div className="db-empty">
          <div className="db-empty-title">No location data</div>
          <div className="db-empty-sub">Records may not yet have a NetSuite location assignment.</div>
        </div>
      ) : (
        <>
          <div className="db-card">
            <div style={{
              display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
              gap: 12, flexWrap: 'wrap',
            }}>
              <div className="db-card-title">Top locations — sorted by pending hours</div>
              <ExportCsvButton
                onExport={() => downloadCsv('by-location', rows, CSV_COLUMNS)}
                title="Download the by-location table as CSV"
              />
            </div>
            <div className="db-card-sub">
              Click a row to open Records filtered to that location.
              Total pending: <strong>{fmtH1(totalPending)}</strong> ·
              Total blocked: <strong>{fmtH1(totalGap)}</strong>
            </div>
            <table className="db-table">
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Site</th>
                  <th className="num">Records</th>
                  <th className="num">Pending hrs</th>
                  <th className="num">Gap hrs</th>
                  <th className="num">Gaps</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((l, i) => (
                  <tr key={i}>
                    <td>{l.ns_location_name}</td>
                    <td>{l.site_code || '—'}</td>
                    <td className="num">{fmtN(l.record_count || 0)}</td>
                    <td className="num">{fmtH1(l.pending_hours || 0)}</td>
                    <td className="num">{fmtH1(l.gap_hours || 0)}</td>
                    <td className="num">{l.gaps > 0 ? fmtN(l.gaps) : '—'}</td>
                    <td className="num">
                      <button type="button" className="btn btn-sm btn-primary"
                        onClick={() => nav.goRecords({ filter: 'all', siteCode: l.site_code || '' })}>
                        Open →
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <InfoModal open={info.open} onClose={info.onClose} title="About By Location" body={helpEntry?.help} />
    </>
  );
}
